// import { ntxAPI } from '@API/axiosNeatex';
// import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
// import type { APIResponse } from '@store/Shared/shared';

// // ===== Types =====

// export type ReportMeta = {
//   pageIndex: number; // ✅ 1-based (mapped from pageIndex)
//   pageSize: number;
//   totalRows: number;
//   totalPages: number;
//   hasPrevPage: number | boolean;
//   hasNextPage: number | boolean;
//   [k: string]: any;
// };

// export type ReportResult<T = any> = {
//   meta: ReportMeta;
//   items: T[];
// };

// // ✅ NEW: shape of API data payload (items varies by report)
// export type PagedApiData<T = any> = {
//   totalItems: number;
//   pageIndex: number; // expected 1-based
//   pageSize: number;
//   items: T[];

//   totalPages?: number | null;
//   hasPrevPage?: boolean | number | null;
//   hasNextPage?: boolean | number | null;

//   [k: string]: any;
// };

// export interface ReportTableState {
//   // result
//   items: any[];
//   meta: ReportMeta | null;

//   // request model (داخل request:{...})
//   request: Record<string, any>;
//   fixedRequest: Record<string, any>;

//   // transport
//   endpoint: string;
//   queryParams?: Record<string, any>;

//   // ui/runtime
//   loading: boolean;
//   error: string | null;
// }

// export interface ReportTablesState {
//   [reportKey: string]: ReportTableState | undefined;
// }

// interface GetReportArgs {
//   reportKey: string;
//   requestOverride?: Record<string, any>;
//   fixedRequestOverride?: Record<string, any>;
// }

// // ===== Helpers =====

// const createInitialReportState = (): ReportTableState => ({
//   items: [],
//   meta: null,

//   request: {
//     pageIndex: 0, // ✅ 1-based (UI)
//     pageSize: 10
//     // includeTotalRows: true
//   },
//   fixedRequest: {},

//   endpoint: '',
//   queryParams: undefined,

//   loading: false,
//   error: null
// });

// const initialState: ReportTablesState = {};

// const ensureReportState = (state: ReportTablesState, reportKey: string): ReportTableState => {
//   // debugger
//   if (!state[reportKey]) state[reportKey] = createInitialReportState();
//   return state[reportKey] as ReportTableState;
// };

// const resetToFirstPage = (t: ReportTableState) => {
//   t.request.pageIndex = 0;
// };

// // ✅ normalize request so server can accept either pageIndex or pageIndex
// const normalizeRequestForServer = (req: Record<string, any>) => {
//   const pageIndex = req.pageIndex ?? req.pageIndex ?? 0;
//   const pageSize = req.pageSize ?? 10;

//   const includeTotalItems = req.includeTotalItems ?? req.includeTotalRows ?? true;

//   return {
//     ...req,
//     // send both to avoid mismatches between APIs
//     // pageIndex,
//     pageIndex: pageIndex,
//     pageSize
//     //  includeTotalRows: includeTotalItems
//   };
// };

// // ✅ map API payload -> our meta
// const buildMetaFromPagedData = (d: PagedApiData<any>): ReportMeta => {
//   const pageIndex = d.pageIndex ?? 1;
//   const pageSize = d.pageSize ?? 10;
//   const totalRows = d.totalItems ?? 0;

//   const computedTotalPages = pageSize > 0 ? Math.ceil(totalRows / pageSize) : 0;
//   const totalPages = (typeof d.totalPages === 'number' ? d.totalPages : null) ?? computedTotalPages;

//   const hasPrev = d.hasPrevPage ?? pageIndex > 1;

//   const hasNext = d.hasNextPage ?? (totalPages > 0 ? pageIndex < totalPages : pageIndex * pageSize < totalRows);

//   // ✅ كل الحقول الإضافية (ديناميكيًا) ما عدا items
//   const { items: _items, ...rest } = d as any;

//   return {
//     ...rest, // ✅ هنا تدخل أي حقول: openingBalance / totalPeriodDr / ... أو أي شيء آخر

//     pageIndex,
//     pageSize,
//     totalRows,
//     totalPages,
//     hasPrevPage: hasPrev,
//     hasNextPage: hasNext
//   };
// };

// // ===== Thunk =====

// export const getReportPagedData = createAsyncThunk(
//   'reportTable/getReportPagedData',
//   async ({ reportKey, requestOverride, fixedRequestOverride }: GetReportArgs, thunkAPI) => {
//     const rootState = thunkAPI.getState() as { reportTable: ReportTablesState };
//     const t = rootState.reportTable[reportKey];

//     if (!t || !t.endpoint) {
//       return thunkAPI.rejectWithValue('Endpoint is not set for this report.');
//     }

//     const finalRequestRaw = {
//       ...t.request,
//       ...t.fixedRequest,
//       ...(fixedRequestOverride || {}),
//       ...(requestOverride || {})
//     };

//     const finalRequest = normalizeRequestForServer(finalRequestRaw);
//     const body = { request: finalRequest };

//     try {
//       // ✅ response is APIResponse<PagedApiData>
//       const { data } = await ntxAPI.post<APIResponse<PagedApiData>>(t.endpoint, body, {
//         params: t.queryParams
//       });

//       if (data?.succeeded === true) {
//         const d = data.data;
//         if (!d) return thunkAPI.rejectWithValue('Empty data payload');

//         const meta = buildMetaFromPagedData(d);
//         const items = d.items ?? [];

//         return { reportKey, meta, items };
//       }

//       return thunkAPI.rejectWithValue(data?.message || 'Fetch failed');
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue(error?.response?.data || 'Fetch failed');
//     }
//   }
// );

// // ===== Slice =====

// const reportTableSlice = createSlice({
//   name: 'reportTable',
//   initialState,
//   reducers: {
//     initReport: (
//       state,
//       action: PayloadAction<{
//         reportKey: string;
//         endpoint: string;
//         initialRequest?: Record<string, any>;
//         fixedRequest?: Record<string, any>;
//         queryParams?: Record<string, any>;
//       }>
//     ) => {
//       const { reportKey, endpoint, initialRequest, fixedRequest, queryParams } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.endpoint = endpoint;

//       if (queryParams) t.queryParams = queryParams;
//       if (fixedRequest) t.fixedRequest = fixedRequest;
//       if (initialRequest) t.request = { ...t.request, ...initialRequest };

//       resetToFirstPage(t);
//     },

//     setReportEndpoint: (state, action: PayloadAction<{ reportKey: string; endpoint: string }>) => {
//       const { reportKey, endpoint } = action.payload;
//       const t = ensureReportState(state, reportKey);
//       t.endpoint = endpoint;
//     },

//     setReportQueryParams: (state, action: PayloadAction<{ reportKey: string; queryParams: Record<string, any> }>) => {
//       const { reportKey, queryParams } = action.payload;
//       const t = ensureReportState(state, reportKey);
//       t.queryParams = queryParams;
//     },

//     setReportRequest: (state, action: PayloadAction<{ reportKey: string; request: Record<string, any> }>) => {
//       const { reportKey, request } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.request = { ...t.request, ...request };
//       resetToFirstPage(t);
//     },

//     patchReportRequest: (state, action: PayloadAction<{ reportKey: string; request: Record<string, any> }>) => {
//       const { reportKey, request } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.request = { ...t.request, ...request };
//     },

//     setReportFixedRequest: (state, action: PayloadAction<{ reportKey: string; fixedRequest: Record<string, any> }>) => {
//       const { reportKey, fixedRequest } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.fixedRequest = fixedRequest;
//       resetToFirstPage(t);
//     },

//     setReportPagination: (state, action: PayloadAction<{ reportKey: string; pageIndex: number; pageSize: number }>) => {
//       const { reportKey, pageIndex, pageSize } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.request = { ...t.request, pageIndex, pageSize };
//     },

//     setReportSorting: (
//       state,
//       action: PayloadAction<{ reportKey: string; sortBy?: string | null; sortDir?: string | null }>
//     ) => {
//       const { reportKey, sortBy, sortDir } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.request = {
//         ...t.request,
//         sortBy: sortBy ?? t.request.sortBy,
//         sortDir: sortDir ?? t.request.sortDir
//       };
//       resetToFirstPage(t);
//     },

//     clearReportData: (state, action: PayloadAction<{ reportKey: string }>) => {
//       const { reportKey } = action.payload;
//       const t = ensureReportState(state, reportKey);

//       t.items = [];
//       t.meta = null;
//       t.loading = false;
//       t.error = null;
//       resetToFirstPage(t);
//     },

//     resetReportState: (state, action: PayloadAction<{ reportKey: string }>) => {
//       state[action.payload.reportKey] = createInitialReportState();
//     },

//     removeReportState: (state, action: PayloadAction<{ reportKey: string }>) => {
//       delete state[action.payload.reportKey];
//     },

//     clearAllReports: state => {
//       Object.keys(state).forEach(k => delete state[k]);
//     }
//   },

//   extraReducers: builder => {
//     builder
//       .addCase(getReportPagedData.pending, (state, action) => {
//         const reportKey = action.meta.arg.reportKey;
//         const t = ensureReportState(state, reportKey);
//         t.loading = true;
//         t.error = null;
//       })
//       .addCase(getReportPagedData.fulfilled, (state, action) => {
//         const { reportKey, meta, items } = action.payload as { reportKey: string; meta: ReportMeta; items: any[] };
//         const t = ensureReportState(state, reportKey);
//         // debugger
//         t.loading = false;
//         t.meta = meta ?? null;
//         t.items = items ?? [];

//         // sync pagination from server
//         if (meta?.pageIndex != null) t.request.pageIndex = meta.pageIndex;
//         if (meta?.pageSize != null) t.request.pageSize = meta.pageSize;
//       })
//       .addCase(getReportPagedData.rejected, (state, action) => {
//         const reportKey = (action.meta as any)?.arg?.reportKey as string | undefined;
//         if (!reportKey) return;

//         const t = ensureReportState(state, reportKey);
//         t.loading = false;
//         t.error = (action.payload as string) ?? 'Fetch failed';
//       });
//   }
// });

// export const {
//   initReport,
//   setReportEndpoint,
//   setReportQueryParams,
//   setReportRequest,
//   patchReportRequest,
//   setReportFixedRequest,
//   setReportPagination,
//   setReportSorting,
//   clearReportData,
//   resetReportState,
//   removeReportState,
//   clearAllReports
// } = reportTableSlice.actions;

// export default reportTableSlice.reducer;

// // Selectors (اختياري)
// export const selectReport = (state: { reportTable: ReportTablesState }, reportKey: string) =>
//   state.reportTable[reportKey];
// export const selectReportRows = (state: { reportTable: ReportTablesState }, reportKey: string) =>
//   state.reportTable[reportKey]?.items ?? [];
// export const selectReportMeta = (state: { reportTable: ReportTablesState }, reportKey: string) =>
//   state.reportTable[reportKey]?.meta ?? null;
// export const selectReportLoading = (state: { reportTable: ReportTablesState }, reportKey: string) =>
//   state.reportTable[reportKey]?.loading ?? false;

import { ntxAPI } from '@API/axiosNeatex';
import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import type { APIResponse } from '@store/Shared/shared';

// ===== Types =====

export type ReportMeta = {
  pageIndex: number;
  pageSize: number;
  totalRows: number;
  totalPages: number;
  hasPrevPage: number | boolean;
  hasNextPage: number | boolean;
  [k: string]: any;
};

export type ReportResult<T = any> = {
  meta: ReportMeta;
  items: T[];
};

export type PagedApiData<T = any> = {
  totalItems: number;
  pageIndex: number;
  pageSize: number;
  items: T[];

  totalPages?: number | null;
  hasPrevPage?: boolean | number | null;
  hasNextPage?: boolean | number | null;

  [k: string]: any;
};

export interface ReportTableState {
  // result
  items: any[];
  meta: ReportMeta | null;

  // request model
  request: Record<string, any>;
  fixedRequest: Record<string, any>;

  // transport
  endpoint: string;
  queryParams?: Record<string, any>;

  // ui/runtime
  loading: boolean;
  error: string | null;
}

export interface ReportTablesState {
  [reportKey: string]: ReportTableState | undefined;
}

interface GetReportArgs {
  reportKey: string;
  requestOverride?: Record<string, any>;
  fixedRequestOverride?: Record<string, any>;
}

// ===== Helpers =====

const cleanRequestObject = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: Partial<T> = {};

  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === '') continue;
    (out as any)[k] = v; // keep false / 0
  }

  return out;
};

const createInitialReportState = (): ReportTableState => ({
  items: [],
  meta: null,

  request: {
    pageIndex: 0,
    pageSize: 10
  },
  fixedRequest: {},

  endpoint: '',
  queryParams: undefined,

  loading: false,
  error: null
});

const initialState: ReportTablesState = {};

const ensureReportState = (state: ReportTablesState, reportKey: string): ReportTableState => {
  if (!state[reportKey]) state[reportKey] = createInitialReportState();
  return state[reportKey] as ReportTableState;
};

const resetToFirstPage = (t: ReportTableState) => {
  t.request.pageIndex = 0;
};

const normalizeRequestForServer = (req: Record<string, any>) => {
  const pageIndex = req.pageIndex ?? 0;
  const pageSize = req.pageSize ?? 10;
  const includeTotalItems = req.includeTotalItems ?? req.includeTotalRows ?? true;

  return cleanRequestObject({
    ...req,
    pageIndex,
    pageSize,
    includeTotalItems
  });
};

const buildMetaFromPagedData = (d: PagedApiData<any>): ReportMeta => {
  const pageIndex = d.pageIndex ?? 1;
  const pageSize = d.pageSize ?? 10;
  const totalRows = d.totalItems ?? 0;

  const computedTotalPages = pageSize > 0 ? Math.ceil(totalRows / pageSize) : 0;
  const totalPages = (typeof d.totalPages === 'number' ? d.totalPages : null) ?? computedTotalPages;

  const hasPrev = d.hasPrevPage ?? pageIndex > 1;
  const hasNext = d.hasNextPage ?? (totalPages > 0 ? pageIndex < totalPages : pageIndex * pageSize < totalRows);

  const { items: _items, ...rest } = d as any;

  return {
    ...rest,
    pageIndex,
    pageSize,
    totalRows,
    totalPages,
    hasPrevPage: hasPrev,
    hasNextPage: hasNext
  };
};

// ===== Thunk =====

export const getReportPagedData = createAsyncThunk(
  'reportTable/getReportPagedData',
  async ({ reportKey, requestOverride, fixedRequestOverride }: GetReportArgs, thunkAPI) => {
    const rootState = thunkAPI.getState() as { reportTable: ReportTablesState };
    const t = rootState.reportTable[reportKey];

    if (!t || !t.endpoint) {
      return thunkAPI.rejectWithValue('Endpoint is not set for this report.');
    }

    const finalRequestRaw = {
      ...t.request,
      ...t.fixedRequest,
      ...(fixedRequestOverride || {}),
      ...(requestOverride || {})
    };

    const finalRequest = normalizeRequestForServer(finalRequestRaw);
    const body = { request: finalRequest };

    try {
      const { data } = await ntxAPI.post<APIResponse<PagedApiData>>(t.endpoint, body, {
        params: t.queryParams
      });

      if (data?.succeeded === true) {
        const d = data.data;
        if (!d) return thunkAPI.rejectWithValue('Empty data payload');

        const meta = buildMetaFromPagedData(d);
        const items = d.items ?? [];

        return { reportKey, meta, items };
      }

      return thunkAPI.rejectWithValue(data?.message || 'Fetch failed');
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data || 'Fetch failed');
    }
  }
);

// ===== Slice =====

const reportTableSlice = createSlice({
  name: 'reportTable',
  initialState,
  reducers: {
    initReport: (
      state,
      action: PayloadAction<{
        reportKey: string;
        endpoint: string;
        initialRequest?: Record<string, any>;
        fixedRequest?: Record<string, any>;
        queryParams?: Record<string, any>;
      }>
    ) => {
      const { reportKey, endpoint, initialRequest, fixedRequest, queryParams } = action.payload;
      const t = ensureReportState(state, reportKey);

      const defaultState = createInitialReportState();

      t.items = [];
      t.meta = null;
      t.loading = false;
      t.error = null;

      t.endpoint = endpoint;
      t.queryParams = queryParams;
      t.fixedRequest = cleanRequestObject(fixedRequest ?? {});

      t.request = cleanRequestObject({
        ...defaultState.request,
        ...(initialRequest ?? {})
      });

      resetToFirstPage(t);
    },

    setReportEndpoint: (state, action: PayloadAction<{ reportKey: string; endpoint: string }>) => {
      const { reportKey, endpoint } = action.payload;
      const t = ensureReportState(state, reportKey);
      t.endpoint = endpoint;
    },

    setReportQueryParams: (state, action: PayloadAction<{ reportKey: string; queryParams: Record<string, any> }>) => {
      const { reportKey, queryParams } = action.payload;
      const t = ensureReportState(state, reportKey);
      t.queryParams = queryParams;
    },

    // ✅ Replace بالكامل بدل merge
    setReportRequest: (state, action: PayloadAction<{ reportKey: string; request: Record<string, any> }>) => {
      const { reportKey, request } = action.payload;
      const t = ensureReportState(state, reportKey);

      t.request = cleanRequestObject({
        pageIndex: 0,
        pageSize: request.pageSize ?? t.request.pageSize ?? 10,
        sortBy: request.sortBy ?? t.request.sortBy,
        sortDir: request.sortDir ?? t.request.sortDir,
        ...request
      });

      resetToFirstPage(t);
    },

    // ✅ Patch يبقى merge للتعديلات الجزئية
    patchReportRequest: (state, action: PayloadAction<{ reportKey: string; request: Record<string, any> }>) => {
      const { reportKey, request } = action.payload;
      const t = ensureReportState(state, reportKey);

      t.request = cleanRequestObject({
        ...t.request,
        ...request
      });
    },

    setReportFixedRequest: (state, action: PayloadAction<{ reportKey: string; fixedRequest: Record<string, any> }>) => {
      const { reportKey, fixedRequest } = action.payload;
      const t = ensureReportState(state, reportKey);

      t.fixedRequest = cleanRequestObject(fixedRequest);
      resetToFirstPage(t);
    },

    setReportPagination: (state, action: PayloadAction<{ reportKey: string; pageIndex: number; pageSize: number }>) => {
      const { reportKey, pageIndex, pageSize } = action.payload;
      const t = ensureReportState(state, reportKey);

      t.request = cleanRequestObject({
        ...t.request,
        pageIndex,
        pageSize
      });
    },

    setReportSorting: (
      state,
      action: PayloadAction<{ reportKey: string; sortBy?: string | null; sortDir?: string | null }>
    ) => {
      const { reportKey, sortBy, sortDir } = action.payload;
      const t = ensureReportState(state, reportKey);

      const nextRequest = {
        ...t.request
      };

      if (sortBy === null) {
        delete nextRequest.sortBy;
      } else if (sortBy !== undefined) {
        nextRequest.sortBy = sortBy;
      }

      if (sortDir === null) {
        delete nextRequest.sortDir;
      } else if (sortDir !== undefined) {
        nextRequest.sortDir = sortDir;
      }

      t.request = cleanRequestObject(nextRequest);
      resetToFirstPage(t);
    },

    clearReportData: (state, action: PayloadAction<{ reportKey: string }>) => {
      const { reportKey } = action.payload;
      const t = ensureReportState(state, reportKey);

      t.items = [];
      t.meta = null;
      t.loading = false;
      t.error = null;
      resetToFirstPage(t);
    },

    resetReportState: (state, action: PayloadAction<{ reportKey: string }>) => {
      state[action.payload.reportKey] = createInitialReportState();
    },

    removeReportState: (state, action: PayloadAction<{ reportKey: string }>) => {
      delete state[action.payload.reportKey];
    },

    clearAllReports: state => {
      Object.keys(state).forEach(k => delete state[k]);
    }
  },

  extraReducers: builder => {
    builder
      .addCase(getReportPagedData.pending, (state, action) => {
        const reportKey = action.meta.arg.reportKey;
        const t = ensureReportState(state, reportKey);
        t.loading = true;
        t.error = null;
      })
      .addCase(getReportPagedData.fulfilled, (state, action) => {
        const { reportKey, meta, items } = action.payload as {
          reportKey: string;
          meta: ReportMeta;
          items: any[];
        };

        const t = ensureReportState(state, reportKey);

        t.loading = false;
        t.meta = meta ?? null;
        t.items = items ?? [];

        if (meta?.pageIndex != null) t.request.pageIndex = meta.pageIndex;
        if (meta?.pageSize != null) t.request.pageSize = meta.pageSize;
      })
      .addCase(getReportPagedData.rejected, (state, action) => {
        const reportKey = (action.meta as any)?.arg?.reportKey as string | undefined;
        if (!reportKey) return;

        const t = ensureReportState(state, reportKey);
        t.loading = false;
        t.error = (action.payload as string) ?? 'Fetch failed';
      });
  }
});

export const {
  initReport,
  setReportEndpoint,
  setReportQueryParams,
  setReportRequest,
  patchReportRequest,
  setReportFixedRequest,
  setReportPagination,
  setReportSorting,
  clearReportData,
  resetReportState,
  removeReportState,
  clearAllReports
} = reportTableSlice.actions;

export default reportTableSlice.reducer;

// ===== Selectors =====

export const selectReport = (state: { reportTable: ReportTablesState }, reportKey: string) =>
  state.reportTable[reportKey];

export const selectReportRows = (state: { reportTable: ReportTablesState }, reportKey: string) =>
  state.reportTable[reportKey]?.items ?? [];

export const selectReportMeta = (state: { reportTable: ReportTablesState }, reportKey: string) =>
  state.reportTable[reportKey]?.meta ?? null;

export const selectReportLoading = (state: { reportTable: ReportTablesState }, reportKey: string) =>
  state.reportTable[reportKey]?.loading ?? false;